import { useEffect, useState } from "react";
import { userRequest } from "../../requestMethods";
import { formatTimeDDMMYYY } from "../../util/helper";
import Loading from "../../components/loading/loading";
import "./monitoring.css";

const getIndicatorStyle = (indicator) => {
  if (indicator === null || indicator === undefined) return "indicator_gray";
  if (typeof indicator === "string") {
    const val = indicator.toLowerCase();
    if (val === "ok" || val === "green" || val === "ativo")
      return "indicator_green";
    if (val === "warning" || val === "yellow" || val === "atencao")
      return "indicator_yellow";
    return "indicator_red";
  }
  if (typeof indicator === "number") {
    if (indicator <= 7) return "indicator_green";
    if (indicator <= 30) return "indicator_yellow";
    return "indicator_red";
  }
  return "indicator_gray";
};

const getIndicatorLabel = (indicator) => {
  if (indicator === null || indicator === undefined) return "—";
  if (typeof indicator === "number") return `${indicator} dias`;
  return indicator;
};

export default function Monitoring() {
  const [data, setData] = useState([]);
  const [filtered, setFiltered] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [search, setSearch] = useState("");

  useEffect(() => {
    fetchData();
  }, []);

  useEffect(() => {
    if (!search.trim()) {
      setFiltered(data);
    } else {
      const q = search.toLowerCase();
      setFiltered(
        data.filter(
          (item) =>
            (item.name || "").toLowerCase().includes(q) ||
            (item.orderRef || "").toLowerCase().includes(q),
        ),
      );
    }
  }, [search, data]);

  const fetchData = async () => {
    setIsLoading(true);
    try {
      const res = await userRequest.get("standard/check");
      setData(res.data);
    } catch (e) {
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="div_custom_">
      {isLoading ? (
        <Loading />
      ) : (
        <>
          <div className="monitoring_header">
            <div>
              <span className="labelTitle">Monitoramento</span>
              <br />
              <span className="labelMsgData">
                Status em tempo real das empresas
              </span>
            </div>
            <input
              className="monitoring_search"
              type="text"
              placeholder="Buscar empresa ou pedido..."
              value={search}
              onChange={(e) => setSearch(e.target.value)}
            />
          </div>

          <div className="monitoring_summary">
            <div className="monitoring_summary_item">
              <span className="monitoring_summary_label">Total</span>
              <span className="monitoring_summary_value">{data.length}</span>
            </div>
            <div className="monitoring_summary_item">
              <span className="monitoring_summary_label">Ok</span>
              <span className="monitoring_summary_value monitoring_value_green">
                {
                  data.filter(
                    (i) => getIndicatorStyle(i.indicator) === "indicator_green",
                  ).length
                }
              </span>
            </div>
            <div className="monitoring_summary_item">
              <span className="monitoring_summary_label">Atenção</span>
              <span className="monitoring_summary_value monitoring_value_yellow">
                {
                  data.filter(
                    (i) =>
                      getIndicatorStyle(i.indicator) === "indicator_yellow",
                  ).length
                }
              </span>
            </div>
            <div className="monitoring_summary_item">
              <span className="monitoring_summary_label">Crítico</span>
              <span className="monitoring_summary_value monitoring_value_red">
                {
                  data.filter(
                    (i) => getIndicatorStyle(i.indicator) === "indicator_red",
                  ).length
                }
              </span>
            </div>
          </div>

          <div className="monitoring_grid">
            {filtered.length === 0 && (
              <div className="monitoring_empty">
                Nenhum registro encontrado.
              </div>
            )}
            {filtered.map((item, idx) => {
              const indicatorClass = getIndicatorStyle(item.indicator);
              return (
                <div
                  key={idx}
                  className={`monitoring_card ${indicatorClass}_border`}
                >
                  <div className="monitoring_card_top">
                    <span className="monitoring_company_name">
                      {item.name || "—"}
                    </span>
                    <span className={`monitoring_badge ${indicatorClass}`}>
                      {getIndicatorLabel(item.indicator)}
                    </span>
                  </div>
                  <div className="monitoring_card_info">
                    <div className="monitoring_info_row">
                      <span className="monitoring_info_label">Pedido</span>
                      <span className="monitoring_info_value">
                        {item.orderRef || (
                          <span className="monitoring_null">Sem pedido</span>
                        )}
                      </span>
                    </div>
                    <div className="monitoring_info_row">
                      <span className="monitoring_info_label">
                        Último pedido
                      </span>
                      <span className="monitoring_info_value">
                        {item.createdAt ? (
                          formatTimeDDMMYYY(item.createdAt)
                        ) : (
                          <span className="monitoring_null">Nunca</span>
                        )}
                      </span>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </>
      )}
    </div>
  );
}
